import type { QCResultStatsResult } from "@/modules/qc/domain/types/result";
import { Card } from "@devhop/ui";
import { formatDateTimeLocal } from "@/shared/lib/date-time";

type QCResultFailedRecordsProps = {
  stats: QCResultStatsResult;
  onRecordClick: (qcStandardId: string, recordId: string) => void;
};

export function QCResultFailedRecords({
  stats,
  onRecordClick,
}: QCResultFailedRecordsProps) {
  if (stats.recentFailed.length === 0) return null;

  return (
    <Card className="p-6" data-tourid="result-failed-records">
      <h2 className="mb-4 font-semibold text-lg">
        ງານທີ່ຕ້ອງແກ້ໄຂ (20 ລາຍການລ່າສຸດ)
      </h2>
      <div className="space-y-2">
        {stats.recentFailed.map((record) => (
          <button
            key={record.id}
            type="button"
            className="flex w-full cursor-pointer items-center justify-between rounded-lg border p-3 text-left transition-colors hover:bg-muted/50"
            onClick={() => onRecordClick(record.qcStandardId, record.id)}
          >
            <div className="flex-1">
              <div className="flex items-center gap-2">
                <span className="font-medium">{record.qcStandardName}</span>
                {record.departmentName && (
                  <span className="text-muted-foreground text-sm">
                    ({record.departmentName})
                  </span>
                )}
              </div>
              <div className="mt-1 flex items-center gap-4 text-muted-foreground text-sm">
                <span>
                  {formatDateTimeLocal(record.inspectedAt).slice(0, 16)}
                </span>
                {record.workItemId && <span>ລະຫັດງານ: {record.workItemId}</span>}
                <span className="text-red-600">
                  ບໍ່ຜ່ານ {record.failCount} ລາຍການ
                </span>
              </div>
              {record.notes && (
                <p className="mt-1 text-muted-foreground text-sm">
                  {record.notes}
                </p>
              )}
            </div>
            <span className="text-primary text-sm">ເບິ່ງລາຍລະອຽດ →</span>
          </button>
        ))}
      </div>
    </Card>
  );
}
